import React from 'react';
import { Navigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useAuth } from '../../context/AuthContext';

/**
 * Higher-order component to protect routes from unauthenticated users.
 * Redirects to /login if the user is not found in AuthContext.
 */
const ProtectedRoute = ({ children, adminOnly = false }) => {
  const { t } = useTranslation();
  const { user, isLoading, isAdmin, isAdminLoading } = useAuth();

  if (isLoading || (adminOnly && isAdminLoading)) {
    return (
      <div className="loading-container">
        <div className="glass-loader">{t('auth.loadingSession')}</div>
      </div>
    );
  }

  if (!user) {
    return <Navigate to="/login" replace />;
  }

  if (adminOnly && !isAdmin) {
    return <Navigate to="/dashboard" replace />;
  }

  return children;
};

export default ProtectedRoute;
